const PayrollService = {
  async saveEmployeePayment(formData) {
    try {
      let url = '/api/payroll/employeePayment';
      let method = 'PUT';
      if (formData.identifier === undefined) {
        const profileLogged = JSON.parse(localStorage.getItem('profile'));
        const { identifier } = profileLogged;

        formData.modUserIdentifier = identifier;

        url = '/api/payroll/employeePayment';
        method = 'POST';
      } else {
        url += '/' + formData.identifier;
      }
      const updatedFormData = {
        ...formData,
        status: formData.status.value
      };
      console.log(updatedFormData);
      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updatedFormData)
      });
      if (response.ok) {
        const newPayroll = await response.json();
        console.log('Employee Payment has been updated:', newPayroll);
      }
    } catch (error) {
      console.log('Error saving Employee Payment ', error);
    }
  },
  async retrieveAllPayrollByAccount() {
    try {
      const { identifier } = JSON.parse(localStorage.getItem('profile'));
      const url = '/api/performance/payroll/profile/' + identifier;
      const response = await fetch(url);
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching Payroll', error);
      throw error;
    }
  },
  async retrievePayroll(identifier) {
    try {
      const response = await fetch('/api/performance/payroll/' + identifier);
      const data = await response.json();

      return data;
    } catch (error) {
      console.error('Error fetching Payroll', error);
      throw error;
    }
  },
  async deletePayroll(identifier) {
    try {
      let url = '/api/performance/payroll/' + identifier;
      let method = 'DELETE';
      const response = await fetch(url, {
        method: method,
        headers: {
          'Content-Type': 'application/json'
        }
      });
      if (response.ok) {
        const newPayroll = await response.json();
        console.log('Payroll has been deleted:', newPayroll);
      }
    } catch (error) {
      console.log('Error deleting Payroll', error);
    }
  }
};
export default PayrollService;
